import * as React from "react";
import Select from "react-select";
export class DownloadSelectionFilterComponent extends React.Component {
    render() {
        const { t, filter } = this.props;
        const selectionFilters = ["Failed", "Finished", "In Progress"];
        const currentFilters = selectionFilters.map((current) => ({
            label: t(current),
            value: current,
        }));
        return (React.createElement(Select, { className: "select-compact", options: currentFilters, value: filter || "", onChange: this.changeFilter, placeholder: t("Select...") }));
    }
    changeFilter = (value) => {
        const { attributeId, onSetFilter } = this.props;
        onSetFilter(attributeId, value !== null ? value.value : null);
    };
}
class DownloadProgressFilter {
    component = DownloadSelectionFilterComponent;
    raw = false;
    matches(filter, value) {
        if (typeof value === "number") {
            return filter === "In Progress";
        }
        switch (value) {
            case "init":
            case "started":
            case "paused":
                return filter === "In Progress";
            case "redirect":
            case "failed":
                return filter === "Failed";
            case "finished":
                return filter === "Finished";
        }
    }
}
export default DownloadProgressFilter;
